import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { usersClient } from "@core/clients";
import { User, UserWithPassword } from "@core/types";
import { queryClient } from "../../config/query-client";

type TVariables = {
  userId: string;
  userPayload: Partial<UserWithPassword>;
};

const useUpdateProfileMutation = (options?: UseMutationOptions<Partial<User>, any, TVariables>) =>
  useMutation(
    ["update-user"],
    async ({ userId, userPayload }) => {
      const data = await usersClient.updateProfile(userId, userPayload);
      return data;
    },
    {
    onSuccess(data, variables, context) {
      queryClient.invalidateQueries(["get-profile"]);
      options?.onSuccess?.(data, variables, context)
    },
      ...options
    }
  );

export default useUpdateProfileMutation;
